import { __rest } from "tslib";
import * as React from 'react';
import AngleRightIcon from '@patternfly/react-icons/dist/js/icons/angle-right-icon';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer';
import { Badge } from '../Badge';
export var NotificationDrawerGroup = function NotificationDrawerGroup(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      count = _a.count,
      isExpanded = _a.isExpanded,
      _a$isRead = _a.isRead,
      isRead = _a$isRead === void 0 ? false : _a$isRead,
      _a$onExpand = _a.onExpand,
      onExpand = _a$onExpand === void 0 ? function (event, expanded) {
    return undefined;
  } : _a$onExpand,
      title = _a.title,
      props = __rest(_a, ["children", "className", "count", "isExpanded", "isRead", "onExpand", "title"]);

  return React.createElement("section", Object.assign({}, props, {
    className: css(styles.notificationDrawerGroup, isExpanded && styles.modifiers.expanded, className)
  }), React.createElement("h1", null, React.createElement("button", {
    className: css(styles.notificationDrawerGroupToggle),
    "aria-expanded": isExpanded,
    onClick: function onClick(e) {
      return onExpand(e, !isExpanded);
    }
  }, React.createElement("div", null, title), React.createElement("div", {
    className: css(styles.notificationDrawerGroupToggleCount)
  }, React.createElement(Badge, {
    isRead: isRead
  }, count)), React.createElement("span", {
    className: "pf-c-notification-drawer__group-toggle-icon"
  }, React.createElement(AngleRightIcon, null)))), children);
};